// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    0,
    0,
    0,
    0
  ],
  "2": [
    0,
    0,
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "区块链技术",
      "tec": "郭朋伟",
      "week": "1-11周",
      "add": "教学楼B座121自控"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "区块链技术",
      "tec": "郭朋伟",
      "week": "1-11单周",
      "add": "教学楼B座121自控"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
